var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "考勤组名称",
      "prop": "checkAttendance_name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入考勤组名称"
    },
    model: {
      value: (_vm.form.checkAttendance_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkAttendance_name", $$v)
      },
      expression: "form.checkAttendance_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上班时间",
      "prop": "work_shift"
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "arrow-control": "",
      "placeholder": "请选择上班时间",
      "format": "HH:mm",
      "value-format": "HH:mm"
    },
    model: {
      value: (_vm.form.work_shift),
      callback: function($$v) {
        _vm.$set(_vm.form, "work_shift", $$v)
      },
      expression: "form.work_shift"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下班时间",
      "prop": "closing_time"
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "arrow-control": "",
      "placeholder": "请选择下班时间",
      "format": "HH:mm",
      "value-format": "HH:mm"
    },
    model: {
      value: (_vm.form.closing_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "closing_time", $$v)
      },
      expression: "form.closing_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "休息开始时间",
      "prop": "restStart_time"
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "arrow-control": "",
      "placeholder": "请选择休息开始时间",
      "format": "HH:mm",
      "value-format": "HH:mm"
    },
    model: {
      value: (_vm.form.restStart_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "restStart_time", $$v)
      },
      expression: "form.restStart_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "休息结束时间",
      "prop": "restEnd_time"
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "arrow-control": "",
      "placeholder": "请选择休息结束时间",
      "format": "HH:mm",
      "value-format": "HH:mm"
    },
    model: {
      value: (_vm.form.restEnd_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "restEnd_time", $$v)
      },
      expression: "form.restEnd_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出勤人",
      "prop": "attendants"
    }
  }, [_c('div', {
    on: {
      "click": _vm.setStaff
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择出勤人",
      "onfocus": "this.blur();"
    },
    model: {
      value: (_vm.form.attendants_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "attendants_name", $$v)
      },
      expression: "form.attendants_name"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.id == null || _vm.form.id == ''),
      expression: "form.id == null || form.id == ''"
    }],
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Add
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.id != null && _vm.form.id != ''),
      expression: "form.id != null && form.id != ''"
    }],
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px #006E4B solid",
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("修改")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择出勤人",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "center": true,
      "close-on-click-modal": false,
      "show-close": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('setStaff', {
    ref: "setStaff",
    attrs: {
      "from": _vm.setStaff
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28936fa9","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/znpb/KqzGl/KqzGl_add.vue
// module id = null
// module chunks = 